import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ServiceProviderAppResource from "./ServiceProviderAppResource";
import ServiceProviderCallToActionTypeAppResource from "./ServiceProviderCallToActionTypeAppResource";

class ServiceProviderCallToActionAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-call-to-action';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/calls/tos/actions';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'url',
            'serviceProviderUuid',
            'serviceProvider',
            'typeUuid',
            'type',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            serviceProvider: ServiceProviderAppResource,
            type: ServiceProviderCallToActionTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            serviceProvider: 'service_provider_uuid',
            type: 'type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            url: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 5000,
                },
            },
            serviceProviderUuid: {
                type: 'string',
                presence: true,
            },
            typeUuid: {
                type: 'string',
            },
        };
    }
}

export default ServiceProviderCallToActionAppResource;
